// 默认区块配置
export const defaultBlockConfig = {
  once: true,
  percent: 0.5,
  throttleTime: 0,
  isEnableOverlap: false,
  closeClick: true,
  closeExpose: false
};
